"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCatalogDateDataset = exports.isCatalogFact = exports.isCatalogMeasure = exports.isCatalogAttribute = exports.catalogItemMetadataObject = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
/* eslint-disable @typescript-eslint/no-empty-interface, import/namespace */
var m = tslib_1.__importStar(require("@gooddata/sdk-model"));
/**
 * Get metadata object that catalog item represents
 * @param catalogItem - catalog item
 * @returns metadata object
 * @deprecated Use {@link @gooddata/sdk-model#catalogItemMetadataObject}
 * @public
 */
exports.catalogItemMetadataObject = m.catalogItemMetadataObject;
var attribute_1 = require("./attribute");
Object.defineProperty(exports, "isCatalogAttribute", { enumerable: true, get: function () { return attribute_1.isCatalogAttribute; } });
var measure_1 = require("./measure");
Object.defineProperty(exports, "isCatalogMeasure", { enumerable: true, get: function () { return measure_1.isCatalogMeasure; } });
var fact_1 = require("./fact");
Object.defineProperty(exports, "isCatalogFact", { enumerable: true, get: function () { return fact_1.isCatalogFact; } });
var dateDataset_1 = require("./dateDataset");
Object.defineProperty(exports, "isCatalogDateDataset", { enumerable: true, get: function () { return dateDataset_1.isCatalogDateDataset; } });
//# sourceMappingURL=index.js.map